import React from 'react';
import Cell, { isPositionInSelection, getFoundWordIndex, getUnfoundWordInfo } from './Cell';
import { GameGrid, Position, PlacedWord } from '../types';
import './Grid.css';

interface GridProps {
  grid: GameGrid;
  currentSelection: Position[];
  foundWords: PlacedWord[];
  foundWordNames: string[];
  allHiddenWords: PlacedWord[];
  gaveUp: boolean;
  onCellMouseDown: (pos: Position) => void;
  onCellMouseEnter: (pos: Position) => void;
  onMouseUp: () => void;
  disabled: boolean;
}

const Grid: React.FC<GridProps> = ({
  grid,
  currentSelection,
  foundWords,
  foundWordNames,
  allHiddenWords,
  gaveUp,
  onCellMouseDown,
  onCellMouseEnter,
  onMouseUp,
  disabled
}) => {
  const handleMouseDown = (pos: Position) => {
    if (!disabled) {
      onCellMouseDown(pos);
    }
  };

  const handleMouseEnter = (pos: Position) => {
    if (!disabled) {
      onCellMouseEnter(pos);
    }
  };

  const handleMouseUp = () => {
    if (!disabled) {
      onMouseUp();
    }
  };

  // Handle mouse leave from grid to cancel selection if mouse goes outside
  const handleMouseLeave = () => {
    // Optionally cancel selection when mouse leaves grid
    // For now, we'll allow selection to continue
  };

  return (
    <div 
      className={`grid-container ${disabled ? 'disabled' : ''}`}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
    >
      <div className="grid">
        {grid.cells.map((row, rowIndex) => (
          <div key={rowIndex} className="grid-row">
            {row.map((cell, colIndex) => {
              const isSelected = isPositionInSelection(cell.position, currentSelection);
              const foundWordIndex = getFoundWordIndex(cell.position, foundWords);
              const isFound = foundWordIndex !== undefined;
              
              // Get unfound word info if gave up
              const unfoundInfo = gaveUp ? getUnfoundWordInfo(cell.position, allHiddenWords, foundWordNames) : undefined;
              const isUnfound = unfoundInfo !== undefined;

              return (
                <Cell
                  key={`${rowIndex}-${colIndex}`}
                  letter={cell.letter}
                  position={cell.position}
                  isSelected={isSelected}
                  isFound={isFound}
                  isUnfound={isUnfound}
                  foundWordIndex={foundWordIndex}
                  unfoundWordIndex={unfoundInfo?.wordIndex}
                  letterIndexInWord={unfoundInfo?.letterIndex}
                  onMouseDown={handleMouseDown}
                  onMouseEnter={handleMouseEnter}
                  onMouseUp={handleMouseUp}
                />
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Grid;
